import { Form, Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { ChapterFormValues } from "src/models/Chapter.model";
import {
  useEditChapterMutation,
  useGetChapterByIdQuery,
} from "src/services/ChapterServices";
import { showToast } from "src/utils/showToaster";
import { object, string } from "yup";
import ChapterViewForm from "./ChapterViewForm";
import CircularProgress from "@mui/material/CircularProgress";
import { useLocation } from "react-router-dom";

const ChapterViewFormWrapper = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const chapterId = queryParams.get("chapterId");
  //State
  const [chapterData, setChapterData] = useState<ChapterFormValues>();

  //API
  const { data, isLoading, isFetching } = useGetChapterByIdQuery(
    {
      id: chapterId,
    },
    { skip: !chapterId }
  );
   
  const [editChapter] = useEditChapterMutation();
 

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setChapterData(data?.data);
      
    }
  }, [data, isLoading, isFetching]);
  // Form Initial Values
  const initialValues: ChapterFormValues = {
    chapterName: chapterData?.chapterName || "",
    chapterContent: chapterData?.chapterContent || "",
    duration: chapterData?.duration || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    chapterName: string().required("Please enter chapter name"),
    chapterContent: string().required("Please enter chapter content"),
    duration: string().required("Please enter duration"),
  });

  // Handle Submit
  const handleSubmit = (
    values: ChapterFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ChapterFormValues>
  ) => {
    editChapter({
      body: values,
      id: chapterId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {(formikProps) => (
        <Form>
          {(isLoading || isFetching) && (
            <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
              <CircularProgress />
            </div>
          )}
          <ChapterViewForm formikProps={formikProps} />
        </Form>
      )}
    </Formik>
  );
};

export default ChapterViewFormWrapper;
